"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customTheme = void 0;
var react_1 = require("@chakra-ui/react");
var colors = {
    styles: {
        global: {
            body: {
                color: "black",
                fontFamily: "Poppins",
            },
        },
    },
};
exports.customTheme = (0, react_1.extendTheme)(colors);
